module.exports = __webpack_public_path__ + "img/cfsp-logo.77b96efb.png";